export const APP_VERSION = '1.0.0.8'
export const API_URL =
  process.env.VUE_APP_API_URL || 'https://pay.market-tips.kontur.ru'
export const FRONTEND_API_URL =
  process.env.VUE_APP_FRONTEND_API_URL || 'https://market-tips.kontur.ru'
export const KONTUR_METRIKA_URL =
  process.env.VUE_APP_KONTUR_METRIKA_URL ||
  'https://metrika.kontur.ru/tracker/market_tips.js'
export const OIC_ISSUER_URL =
  process.env.VUE_APP_OIC_ISSUER_URL || 'https://identity.testkontur.ru'
export const TP_WIDGET_URL =
  process.env.VUE_APP_ENV === 'production'
    ? 'https://tp.kontur.ru/support/support_center.js'
    : 'https://tp.testkontur.ru/support/support_center.js'
